import { render, staticRenderFns } from "./CustomerFooter.vue?vue&type=template&id=aebecdb8&"
import script from "./CustomerFooter.vue?vue&type=script&lang=js&"
export * from "./CustomerFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QFooter,QToolbar,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QFooter,QToolbar,QBtn})
